export const REQUESTED_BY_CUSTOMER = 'Requested by customer';
export const DUPLICATE = 'Duplicate';
export const FRAUDULENT = 'Fraudulent';
export const OTHER = 'Other';
export const NO_REASON = 'NA';

export const REFUND_REASONS = [
  {
    label: REQUESTED_BY_CUSTOMER,
    value: REQUESTED_BY_CUSTOMER,
    isSingle: true,
  },
  { label: DUPLICATE, value: DUPLICATE, isSingle: true },
  { label: FRAUDULENT, value: FRAUDULENT, isSingle: true },
  { label: OTHER, value: OTHER, isSingle: true },
];

export const FEE_COMMISSION = 'commission';
export const FEE_MARKETPLACE = 'marketplace';
export const FEE_BUSINESS_CARD = 'business_card';
export const FEE_MARKETPLACE_VARIABLE = 'marketplace_variable';
export const FEE_COST_ESTIMATION = 'cost_estimation';
export const FEE_TXTPAY_JAVELIN = 'txtpay_javelin';
export const FEE_TXTPAY_COMPANY = 'txtpay_company';
